export type IntegrationEnvironment = {
  api_base: string;
  oauth_authorize: string;
  oauth_token: string;
  oauth_revoke: string;
  practitioner_login?: string;
  openapi_spec?: string;
};

export const INTEGRATION_ENVIRONMENTS = {
  sandbox_us: {
    api_base: "https://api-us-snd.fullscript.io/api",
    oauth_authorize: "https://api-us-snd.fullscript.io/api/oauth/authorize",
    oauth_token: "https://api-us-snd.fullscript.io/api/oauth/token",
    oauth_revoke: "https://api-us-snd.fullscript.io/api/oauth/revoke",
    practitioner_login: "https://us-snd.fullscript.io/login",
    openapi_spec: "https://us-snd.fullscript.io/docs/api/open-api/v1/openapi.json",
  },
  sandbox_ca: {
    api_base: "https://api-ca-snd.fullscript.io/api",
    oauth_authorize: "https://api-ca-snd.fullscript.io/api/oauth/authorize",
    oauth_token: "https://api-ca-snd.fullscript.io/api/oauth/token",
    oauth_revoke: "https://api-ca-snd.fullscript.io/api/oauth/revoke",
    practitioner_login: "https://ca-snd.fullscript.io/login",
    openapi_spec: "https://ca-snd.fullscript.io/docs/api/open-api/v1/openapi.json",
  },
  production_us: {
    api_base: "https://api-us.fullscript.io/api",
    oauth_authorize: "https://api-us.fullscript.io/api/oauth/authorize",
    oauth_token: "https://api-us.fullscript.io/api/oauth/token",
    oauth_revoke: "https://api-us.fullscript.io/api/oauth/revoke",
    practitioner_login: "https://us.fullscript.com/login",
    openapi_spec: "https://us.fullscript.com/docs/api/open-api/v1/openapi.json",
  },
  production_ca: {
    api_base: "https://api-ca.fullscript.io/api",
    oauth_authorize: "https://api-ca.fullscript.io/api/oauth/authorize",
    oauth_token: "https://api-ca.fullscript.io/api/oauth/token",
    oauth_revoke: "https://api-ca.fullscript.io/api/oauth/revoke",
    practitioner_login: "https://ca.fullscript.com/login",
    openapi_spec: "https://ca.fullscript.com/docs/api/open-api/v1/openapi.json",
  },
} as const satisfies Record<string, IntegrationEnvironment>;
